<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tocheading">Contents</h1>
<h2 class="toc_chap"><a href="#/xhtml/04_Introduction">Introduction</a></h2>
<h2 class="toc_chap"><a href="#/xhtml/Chap1">The Normandy Battlefield</a></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap2" title="Link target outside of Sample">The Armoured Divisions</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap3" title="Link target outside of Sample">Camouflage &amp; Markings</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap4" title="Link target outside of Sample">Model Showcase</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap5" title="Link target outside of Sample">Modelling Products</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap6" title="Link target outside of Sample">The Armoured Brigades</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap7" title="Link target outside of Sample">The Royal Artillery</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap8" title="Link target outside of Sample">The Royal Marine Armoured Support Group</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap9" title="Link target outside of Sample">Technical Details and Modifications</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap10" title="Link target outside of Sample">Appendices</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap11" title="Link target outside of Sample">Product Contact List</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/Chap12" title="Link target outside of Sample">Acknowledgements</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?6e57a36d